// @import_dependencies
import { store } from 'app_storage/redux-storage'
// @end

// @import services
import { Http, HttpCustomStructure } from 'app_utils/http'
import { ScreenNotificationsUtil } from 'app_utils/screenNotification'
// @end

// @import utilities
// @end

// @import types
import {IFetchScheduling, IFetchSchedulingExtend} from 'app_types/campus/academic/schedulingTypes'
// @end

class SchedulingService {

  private token: string
  private storeObject: any
  private Http: any
  private screenNotification: ScreenNotificationsUtil

  /*===============================================
  =            Estructura de un metodo            =
  ================================================
    // La estructura de un metodo debe ser la siguiente:
    public methodName = () => {}
  /*======  End of Estructura de un metodo  =====*/

  constructor () {
    this.Http = Http
    this.storeObject = store
    this.screenNotification = new ScreenNotificationsUtil()
  }

  refreshAuthToken = () => {
    let auth = this.storeObject.getState().auth
    this.token = (auth.user?.token) ? auth.user.token : ''
  }

  fetchSchedulingData = async (params: any, options: {showError: boolean} = {showError: true}) => {
    this.refreshAuthToken()

    let responseData: IFetchScheduling

    const queryData: HttpCustomStructure = {
      method: 'POST',
      url: `/api/data/course-scheduling/fetch-course-scheduling-by-program/${params.moodle_id}`,
      auth_token: this.token,
      params,
    }

    responseData = await this.Http.send(queryData)

    if (responseData.code === 200) {
      return responseData
    } else {
      if (options && options.showError) this.screenNotification.fire(responseData)
    }

    return false
  }

  fetchSchedulingExtendData = async (params: any, options: {showError: boolean} = {showError: true}) => {
    this.refreshAuthToken()

    let responseData: IFetchSchedulingExtend

    const queryData: HttpCustomStructure = {
      method: 'POST',
      url: `/api/data/course-scheduling/fetch-course-scheduling-extend`,
      auth_token: this.token,
      params,
    }

    responseData = await this.Http.send(queryData)

    if (responseData.code === 200) {
      return responseData
    } else {
      if (options && options.showError) this.screenNotification.fire(responseData)
    }

    return false
  }

}

export default SchedulingService
